
import { AnimatePresence } from "framer-motion";
import { ListViewEntry } from "./ListViewEntry";
import { JournalEntry } from "./types";

interface EntriesListViewProps {
  entries: JournalEntry[];
  onLike: (id: string) => void;
  onDelete: (id: string) => void;
}

export const EntriesListView = ({ entries, onLike, onDelete }: EntriesListViewProps) => {
  return (
    <div className="space-y-4">
      <AnimatePresence>
        {entries.map((entry) => (
          <ListViewEntry 
            key={entry.id} 
            entry={entry} 
            onLike={onLike} 
            onDelete={onDelete} 
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
